module.exports = __webpack_public_path__ + "static/media/04.40eb4ec5.jpg";